import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { RequestJobexpsListingDto, RequestJobexpsViewDto } from '../dto/jobexps.dto';

@Injectable()
export class JobexpsNestApi {

  private service: string = '';
  private model: string = 'Jobexps';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(payload: RequestJobexpsListingDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'listing';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public view(payload: RequestJobexpsViewDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'view';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/Jobexps.api.ts